



































import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Modal from '@/shared/components/Modal/Modal.vue';
import RadioBox from '@/shared/components/RadioBox/RadioBox.vue';
import EarlyRenewal from '@/shared/components/EarlyRenewal/EarlyRenewal.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';

import EmpiricusRewardsForm from './EmpiricusRewardsForm.vue';
import PaymentActions from '../../../PaymentActions/PaymentActions.vue';

import { EPaymentMethodTypes } from '@/helpers/enums';

import { Payment } from '@/classes/Checkout/Payment';
import { IRewardsSummary } from '@/interfaces/Rewards';
import { ICheckoutCartOffer, ICheckoutCartOfferPrice } from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    Modal,
    RadioBox,
    EarlyRenewal,
    PaymentActions,
    EmpiricusRewardsForm,
    ScreenSizeVisibility,
  }
})
export default class EmpiricusRewards extends Vue {
  public $refs!: {
    form: EmpiricusRewardsForm,
  };

  @Prop()
  private readonly type?: EPaymentMethodTypes;

  @Prop()
  private readonly active?: boolean;

  @Prop()
  private readonly isUpsell!: boolean;

  @Prop()
  private readonly validatePaymentType!: Function;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: Payment;

  @CheckoutModule.Getter('isRenewal')
  private isRenewal: boolean;

  @CheckoutModule.Getter
  private selectedOfferPrice!: ICheckoutCartOfferPrice;

  @CustomerModule.State
  private rewardsSummary: IRewardsSummary;

  private get remainingBalance (): number {
    if (!this.selectedOfferPrice) return this.rewardsSummary.point;

    const balance = Number(this.rewardsSummary.point) - Number(this.selectedOfferPrice.points_price);

    return balance ? balance : 0;
  }

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get paymentTypes () {
    return EPaymentMethodTypes;
  }
}
